import React,{useEffect} from 'react'
import { Helmet } from 'react-helmet';
import Img2 from '../assets/img/Img2.png'
import Img3 from '../assets/img/Img3.png'
import Img4 from '../assets/img/Img4.png'
import Img5 from '../assets/img/Img5.png'
import Img6 from '../assets/img/Img6.png'
import Img7 from '../assets/img/Img7.png'
import Img8 from '../assets/img/Img8.png'
import Img9 from '../assets/img/Img9.png'
import Img10 from '../assets/img/Img10.png'
import Img11 from '../assets/img/Img11.png'
import Img12 from '../assets/img/Img12.png'
import Img13 from '../assets/img/Img13.png'
import Img27 from '../assets/img/Img27.png'
// import GirlPic1 from '../assets/img/Girl-Pic-1.png'
// import GirlPic2 from '../assets/img/Girl-pic-2.png'
// import GirlPic3 from '../assets/img/Girl-pic-3.png'
// import BoyPic1 from '../assets/img/Boy-pic-1.png'
// import BoyPic2 from '../assets/img/Boy-pic-2.png'
import Recruiters from '../assets/img/Recruiters.png'
import { Link } from 'react-router-dom'
import Video from '../assets/video/techblume-video.mp4'

const Home = () => {
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
    document.body.style.overflow = 'auto'; // Enable scrolling
  }, []);
  return (
    <>

        <Helmet>
        <title>Become a Certified Full Stack Developer or Data Scientist Online with Techblume</title>
      </Helmet>

    <div className='main-container'>
       <div className="section2">
          <div className="text1">
            <h1>
            The <span>Smart</span> <br />
            Choice For <span>Future</span>
            </h1>
            <h6>
            Techblume Software Solutions is a cutting edge online Bootcamp offering expert - led classes in Full Stack Development, Web Development, Data Science, Cybersecurity, UI / UX design and more perfect for undergraduates, graduates, beginners and working professionals. Join with us for enhancing your skills through our industry experts.            </h6>
            <div className='icons'>
                 <img src={Img11} alt="Img11" />
                 <div className='icon-txt'>
                 Learn The Latest Skills
                 </div>
            </div>
            <div className='icons'>
                 <img src={Img12} alt="Img12" />
                 <div className='icon-txt'>
                 Get Ready For a Career
                 </div>
            </div>
            <div className='icons'>
                 <img src={Img13} alt="Img13" />
                 <div className='icon-txt'>
                 Easily Accessible
                 </div>
            </div>
            <div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginTop: '16px'
  }}
>
  {/* Join Now Button */}
  
  <div className="booking-button">
    <Link to="/bookings">Join Now!</Link>
  </div>

  {/* WhatsApp Button */}
 <a
  href="https://wa.me/919686430320?text=I%20am%20interested%20in%20Techblume%20Career%20Course"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-cta"
>
  <span className="wa-icon">💬</span>
  <span className="wa-text">Chat on WhatsApp</span>
</a>
</div>

          </div>
          <img src={Img4} alt="Img10" className='Img4'/>
       </div>
       <div className="section1">
       <div  className='company'>
         <img src={Img2} alt="Img2" className='Img2'/>
         <img src={Img3} alt="Img3" className='Img3'/>
       </div>
       </div>
       <div className="section2">
            <img src={Img10} alt="Img4" className='Img4'/>
          <div className="text1">
            <h3><span>Community Hub</span> - Share Your Thoughts and Ideas</h3>
            <p>Explore our vibrant Community Hub – your go-to place for engaging discussions, shared insights, and collective support. Connect with a diverse group of learners and expand your horizons. Embark on a journey of collaborative learning and growth with us!</p>
          </div>
       </div>
       <div className="section3">
        <p>Why Choose Us?</p>
        {/* <h1>Benefits of online tutoring services with us</h1> */}
        <section className='grid1'>
              <div>
                <h1>01</h1>
                 <h2>Flexible Learning Schedule</h2>
                 <p>Fit your coursework around your existing commitments and obligations efficiently.</p>
                 <img src={Img5} alt="Img5" />
              </div>

              <div>
                <h1>02</h1>
                 <h2>Expert Instruction</h2>
                 <p>Learn from industry experts who have hands-on experience in design and development.</p>
                 <img src={Img5} alt="Img5" />
              </div>

              <div>
                <h1>03</h1>
                 <h2>Diverse Course Offerings</h2>
                 <p>Explore a wide range of design and development courses covering various topics.</p>
                 <img src={Img5} alt="Img5" />
              </div>

              <div>
                <h1>04</h1>
                 <h2>Updated Curriculum</h2>
                 <p>Access courses with up-to-date content reflecting the latest trends and industry practices.</p>
                 <img src={Img5} alt="Img5" />
              </div>

              <div>
                <h1>05</h1>
                 <h2>Industrial Projects and Assignments</h2>
                 <p>Develop a portfolio showcasing your skills and abilities to potential employers.</p>
                 <img src={Img5} alt="Img5" />
              </div>

              <div>
                <h1>06</h1>
                 <h2>Interactive Learning Environment</h2>
                 <p>Collaborate with fellow learners, exchanging ideas and feedback to enhance your understanding.</p>
                 <img src={Img5} alt="Img5" />
              </div>
        </section>
       </div>

      
    </div>


<div className="wd-section5">
<main>
<section>
    <h1>Schedule Your Free Consultation</h1>
    <h2>Need Help? Get Your Questions Answered Now!</h2>
    <p>Reach out to our Academic Counsellor today for answers to all your questions!</p>
    <Link to='/bookings'>Book your slot now!</Link>
</section>
<img src={Img27} alt="Img27" />
</main>
</div>

   <div className="main-container">

      <div className="section4">
           <h1>Our Courses</h1>
           <p>Empower Your Future with Top-Tier Learning Opportunities</p>
           <div className='grid2'>
              <section>
              <img src={Img6} alt="Img6" />
              <h1>Full Stack Web Development</h1>
              <p>Learn full-stack web development with expertise in front-end and back-end technologies, including HTML, CSS, JavaScript, and server-side programming, to build complete and dynamic websites and applications.</p>
              </section>

              <section>
              <img src={Img7} alt="Img7" />
              <h1>Data Science</h1>
              <p>Master data science with a focus on advanced analytics, statistical methods, and machine learning techniques, including Python, SQL, and data visualization, to uncover insights and drive data-driven decision-making.</p>              </section>
              <section>
              <img src={Img8} alt="Img9" />
              <h1>Cybersecurity</h1>
              <p>Learn to safeguard digital systems and data. Master key principles like threat detection, risk assessment, encryption, and incident response to protect against cyber threats.</p>
              </section>

              <section>
              <img src={Img9} alt="Img10" />
              <h1>UI/UX Design</h1>
              <p>Master UI/UX design principles, including user research, wireframing, prototyping, and visual design. Create intuitive, user-centered products for seamless digital experiences.</p>
              </section>
           </div>
       </div>

       {/* <div className='home-section5'>
        <h1>Placements</h1>
       </div> */}

       <div className="section4">
        <h1>Path to Tech Excellence</h1>
        <p>Achieve your goals with proven methods and expert guidance.</p>
        <div className='youtube-video'>
        {/* <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/XmWkcePhf84?si=FHdIceEnlHrMBWiy&autoplay=0"
        frameBorder="0"
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ borderRadius: '5px' }}
        title="YouTube video player"
        className='techblume-video'
      ></iframe> */}
<video
      className="techblume-video"
      width="100%"
      height="100%"
      controls
      style={{ borderRadius: '5px' }}
    >
      <source src={Video} type="video/mp4" />
     
    </video>
        </div>
       </div> 


       <div className="section4">
        <h1 style={{marginTop:'1.5rem'}}>Our Alumni Success Stories</h1>
        <p>See how our alumni turned skills into success, inspiring future innovators</p>

        <div className='alumini-section'>
             <div>
              {/* <img src={GirlPic1} alt="GirlPic1" /> */}
              <h1>Aurelia Finch</h1>
              <h3>Cloud Application Engineer</h3>
<p>Techblume transformed my career with flexible schedules, hands-on projects, and expert career support. I gained essential skills to become a Data Scientist. The curriculum ensured I was industry-ready from day one!</p>
<h4>Rating : ⭐⭐⭐⭐⭐</h4>
             </div>

             <div>
              {/* <img src={BoyPic1} alt="BoyPic1" /> */}
              <h1>Zephyr Quinn</h1>
              <h3>Software Engineer</h3>
<p>Techblume’s curriculum and coding projects helped me grow into a Software Engineer. I developed vital skills and confidence with personalized support. I was job-ready and prepared for the industry!</p>
<h4>Rating : ⭐⭐⭐⭐⭐</h4>
             </div>

             <div>
              {/* <img src={GirlPic2} alt="GirlPic2" /> */}
              <h1>Elowen Hayes</h1>
              <h3>Data Analyst</h3>
<p>Techblume offers hands-on projects and real-world datasets to excel in IT. Their flexible schedules and career support gave me the skills to succeed as a Data Analyst. The curriculum prepares you for the industry!</p>
<h4>Rating : ⭐⭐⭐⭐⭐</h4>
             </div>

             <div>
              {/* <img src={GirlPic3} alt="GirlPic3" /> */}
              <h1>Evander Locke</h1>
              <h3>Research Scientist</h3>
<p>Techblume gave me the skills and knowledge to succeed as a Research Scientist. Through hands-on projects and mentorship, I thrived in Data Science. Their career guidance was key in this competitive field.</p>
<h4>Rating : ⭐⭐⭐⭐⭐</h4>
             </div>

             <div>
              {/* <img src={BoyPic2} alt="BoyPic2" /> */}
              <h1>Isolde March</h1>
              <h3>Mobile App Developer</h3>
<p>Techblume’s Full Stack Development course helped me transition into Mobile App Development. Through projects and mentorship, I learned to build high-performance apps. Career support was key to my success.</p>
<h4>Rating : ⭐⭐⭐⭐⭐</h4>
             </div>
        </div>
       
       </div> 

       

<div className='wd-section4'>
            <h1>Gateway to Top Recruiters</h1>
             <img src={Recruiters} alt="" />
       </div>
   </div>
    </>
  )
}

export default Home
